import { useEffect, useRef, useState } from "react"

/**
 * FloatingCta のスクロール先とセットで使うフック。
 * targetRef を付けた要素が視界に入ると isCtaHidden が true になる。
 */
export function useFloatingCtaTarget<T extends HTMLElement = HTMLDivElement>() {
    const targetRef = useRef<T>(null)
    const [isCtaHidden, setIsCtaHidden] = useState(false)

    useEffect(() => {
        const target = targetRef.current
        if (!target || typeof IntersectionObserver === "undefined") return

        const observer = new IntersectionObserver(
            ([entry]) => setIsCtaHidden(entry.isIntersecting),
            { rootMargin: "0px 0px -15% 0px" }
        )
        observer.observe(target)

        return () => observer.disconnect()
    }, [])

    const scrollToTarget = () => {
        targetRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "start",
        })
    }

    return { targetRef, isCtaHidden, scrollToTarget }
}
